var _rect, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFinland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    viewBox: "37.62 0 27 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.62,
    width: 27,
    height: 14,
    fill: "#fff",
    strokeWidth: 0.046417
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.052632 0 0 .040936 37.62 0)",
    points: "121 212 0 212 0 129.3 121 129.3 121 0 203.7 0 203.7 129.3 513 129.3 513 212 203.7 212 203.7 342 121 342",
    fill: "#2e52b2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinland);
export default __webpack_public_path__ + "static/media/finland.59406edefc43ef8ee1b05b3541b0dfc1.svg";
export { ForwardRef as ReactComponent };